import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Bad Request 404</h2>
        </div>
    );
};

export default NotFound;